'use strict';

/* Controllers */

app.controller('LandingPageController', ['$scope', '$rootScope', '$routeParams', '$location', 'User', 'Helper', 'Popup', 'Venue', 
	function($scope, $rootScope, $routeParams, $location, User, Helper, Popup, Venue) {

        // set application flow
        $rootScope.globals.flow = 'send-drink-money';

		// init scope services
		$scope.User = User;

		// init scope vars
        $scope.username = $routeParams.username || null;

    	
    	if( $scope.username !== null ){

	        // get user by the username from url
	        User.getPublicUserDetails($routeParams.username, function(resp, status){

	            if( status == 200 ){
                    // check if user is logged in and if its the same user
                    if( typeof $rootScope.globals.currentUser != 'undefined' && $rootScope.globals.currentUser.id == resp.data.user.id ){
                        Popup.error("You can't send a gift to yourself.", function(){
                            $location.path('/');
                        });
                    }
                    else{
                        // save user as selected one
                        $rootScope.globals.selectedUser = resp.data.user;
                        
                        // save selected user to browser local storage
                        Helper.updateLocalStorageWithGlobalVariable();
                    }
	            }
	            else{
	            	// something went wrong, wrong username?
	                $location.path('/');
	            }
	        });
    	}


    	/**
    	 * function that handles when the send drink button is clicked
    	 */
    	$scope.sendDrink = function(){
            // Card #806: Multi-Currency / Multi-Gateway Feature
            Popup.error("We are making changes to improve this feature.  It will be available again soon.");
            // if( $scope.username !== null && $rootScope.globals.selectedUser ){
            //     var selected_user = $rootScope.globals.selectedUser;
            //     // if user is selected and checked in, skip venue selection
            //     if( User.isCheckedIn(selected_user) ){
            //         // get venue details
            //         var venue_id = User.getCheckedInVenueId(selected_user);
            //         $scope.getVenueAndRedirect(venue_id);
            //     }
            //     else{
            //         // user is selected, skip one step
            //         $location.path('/venues');
            //     }
            // }
            // else{
            //     // go to page for user selection
            //     $location.path('/select-user/drink');
            // }
        }


        /**
         * function that handles when the send money button is clicked
         */
        $scope.sendMoney = function(){
            // Card #806: Multi-Currency / Multi-Gateway Feature
            Popup.error("We are making changes to improve this feature.  It will be available again soon.");
    		// if( $scope.username !== null && $rootScope.globals.selectedUser ){
    		// 	// user is selected, skip one step
	    	// 	$location.path('/select-money-amount');
    		// }
    		// else{
    		// 	// go to page for user selection
	    	// 	$location.path('/select-user/send-money');
    		// }
    	}


        /**
         * function for getting data for venue and redirecting
         */
        $scope.getVenueAndRedirect = function(venue_id){

            Venue.getSingle(venue_id, function(resp, status){

                if( status == 200 ){
                    $rootScope.globals.selectedVenue = resp.data.venue;

                    // update local storage
                    Helper.updateLocalStorageWithGlobalVariable();

                    $location.path('/menu');
                }
                else{
                    Popup.error('Could not get venue from server.');
                }

            });
        }
	}]);